import React from 'react';
import { Link, useParams } from 'react-router-dom';
import cn from 'classnames';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import styles from './index.module.scss';

import { If } from 'utils';
import { PageErrorUi, UiKit } from 'components';
import Store from '../Store';
import Loader from './Loader';
import ZeroState from '../ZeroState';
import { useAppContext } from 'utils/hooks';
import { useAddOnStoreConnect } from '../../hooks';

export default function Connect() {
  const { sellerId } = useParams();

  const { appName } = useAppContext();
  const {
    stores,
    isError,
    isLoading,
    isConnecting,
    connectingStore,
    onConnect,
    onReload
  } = useAddOnStoreConnect(sellerId);

  const supportedStores = _get(stores, 'supportedStores', []);
  const unSupportedStores = _get(stores, 'unSupportedStores', []);
  const hasStores = !_isEmpty([...supportedStores, ...unSupportedStores]);

  const eligibleStores = supportedStores.map(store => {
    const storeUrl = _get(store, 'store_url', '');
    return (
      <Store
        key={storeUrl}
        data={store}
        onConnect={onConnect}
        isConnecting={isConnecting}
        connectingStore={connectingStore}
      />
    );
  });

  const ineligibleStores = unSupportedStores.map(store => {
    const storeUrl = _get(store, 'store_url', '');
    return <Store key={storeUrl} data={store} />;
  });

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3>Available Stores via ShipStation</h3>
        <p>You can also connect additional stores later in settings.</p>
      </div>
      <PageErrorUi
        isError={isError}
        onReload={() => onReload()}
        msg="Failed to load the stores."
        wrapperClassName={styles.errorWrapper}
        contentClassName="pb-0"
      >
        <Loader isLoading={isLoading}>
          <If test={hasStores} otherwise={<ZeroState />}>
            <div className={styles.stores}>{eligibleStores}</div>
            <If test={!_isEmpty(ineligibleStores)}>
              <div className={styles.unSupportedStores}>
                <div className={styles.unSupportedStoresHeader}>
                  <p>Unsupported Stores on {appName}</p>
                </div>
                <div
                  className={cn(styles.stores, styles.unSupportedStoresContent)}
                >
                  {ineligibleStores}
                </div>
              </div>
            </If>
          </If>
          <Link to="/connect-store">
            <UiKit.Button size="lg" className="w-100">
              {hasStores ? 'Add another store' : 'Connect a store'}
            </UiKit.Button>
          </Link>
        </Loader>
      </PageErrorUi>
    </div>
  );
}
